import { Component, OnInit,ViewChild } from '@angular/core';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import { TableConstantsModule } from 'src/app/common/constants/tableconstants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ToastrService } from 'ngx-toastr';
import { ThrowStmt } from '@angular/compiler';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { nodeChildrenAsMap } from '@angular/router/src/utils/tree';
import { theme } from 'highcharts';
import { element } from 'protractor';

@Component({
  selector: 'app-edit-weightage',
  templateUrl: './edit-weightage.component.html',
  styleUrls: ['./edit-weightage.component.css']
})
export class EditWeightageComponent implements OnInit {
  statehierachyDataList : object = {AssesmentList:{},StateList:[],DistrictList:[]};
  userdetails: any;
  selectedstate : any;
  selecteddistrict : any;
  editweightfilter: object = {'ay':"",'lu':"","month":""};
  validation : object = {ay : true,state:true,district:true,month:true};
  stateArrayList: any[];
  statelists: any[];
  distrctentityList: any[];
  filterdistrict: any;
  showdistdrop: boolean;
  showtabledata: boolean;
  activeSpinner: boolean;
  monthList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  monthsList: any;
  selectedMonth: any;
  reportsdata: any;
  hierarchyData: any[];
  tableData: any[];
  showbuttons: boolean;
  fetchtableData: any[];
  fetchweights: any = [];
  labelData: any = [];
  childList: any[];
  yearDropDownList: any;
  dateofmeetingLabel: any;
  approvalbutton: boolean;
  assesmentlist: any;

  constructor(public tableconstants : TableConstantsModule,
    private submitdataSerivce : SubmitdataService,
    private constants : ConstantsModule,
    private utils : UtilsModule,
    private logsrv : AuthloginService,
    private toastr : ToastrService,) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.getdynamicYears();
    this.initializeOnStateLoad(null);
  }
  initializeOnStateLoad(call){
    this.userdetails = this.logsrv.checkloginstatus();
    if(this.userdetails!=null && this.userdetails!=undefined){
      // console.log("gggggg")
      if(this.userdetails['roles'][0] == "ADMIN"){
        // console.log("if")
        // console.log(this.approvalbutton)
        this.approvalbutton  = true;
      } else{
        // console.log("else")
        // console.log(this.approvalbutton)
        this.approvalbutton = false;
      }
    }
    this.monthsList = this.monthList;
    // this.yearDropDownList = this.submitdataSerivce.getassesmentYear();
    // this.editweightfilter['ay'] = this.yearDropDownList[this.yearDropDownList.length-1];
    this.getstateslist();
    if(call){
      this.getWeightsData();
    }
    this.setCurrentMonthDefault();
  }
  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }    
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.assesmentlist = data['data'];
    });
    this.editweightfilter['ay'] = dropDownYear;
  }
  getAssesmentYear(){
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.statehierachyDataList['AssesmentList'] = data['data'];
    });
    // this.statehierachyDataList['AssesmentList'] = this.submitdataSerivce.getassesmentYear();
  }
  selectOption(month){
    this.selectedMonth = month
  }
  getstateslist(){
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
            // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);

          });
        })
      }
    });
  
  }
  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.editweightfilter['month'] = currentmonthObj['key'];
  }
  // showdistrictdropdown(stateuuid){
  //   this.filterdistrict = stateuuid;
  //   if(stateuuid){
  //     this.showdistdrop = true;
  //   } else{
  //     this.showdistdrop = false;
  //   }
  //   if(this.showdistdrop){
  //     this.getDistrictList();
  //   }
  //   // this.selectedId.emit(stateuuid)
  // }
  getDistrictList(){
     this.distrctentityList = [];
    // this.selectdistrict = undefined;
    let postdata = {
      'pType':this.constants.LOCATION_CONSTANT['STATE'],
      'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.filterdistrict
    }
    this.submitdataSerivce.getLocationListforUser(postdata).subscribe(data =>{
      if(Array.isArray(data)){
       this.distrctentityList = data;
      }
     
  },function(err){
      this.activespineer = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    })
  }
  getWeightsData(){
      this.showtabledata = true;
      this.activeSpinner = true;
      this.tableData = [];
      let postdata = {
         "ay" : this.editweightfilter['ay'],
         "view" : this.constants.VIEWS['admin'],
         "component":this.constants.COMPONENT['WEIGHTS_DATA'],
         "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
         "userType" : this.userdetails['roles'][0],
         "lu" : this.selecteddistrict,
         "subTp" : this.editweightfilter['month']
  
      }
      this.submitdataSerivce.getValidateReports(postdata).subscribe(data =>{
        this.reportsdata = data;
        if(Object.keys(this.reportsdata).length > 0){
          this.fetchdata();
        } else{
          this.tableData = [];
        }
        this.activeSpinner =false;
      });
    // }
    }
    fetchdata(){
      this.hierarchyData = []
      this.activeSpinner = true;
        this.submitdataSerivce.FetchIndicators(this.editweightfilter).subscribe(data =>{
          this.hierarchyData = data;
          this.indicatorhierarcydata(data);
          // this.preparedataforhtml(data);
          this.activeSpinner = false;
        });
    }
    indicatorhierarcydata(data){
      let checkisready = 0;
      data.forEach(theme => {
        let i = 0;
        theme['childList'].forEach(indlist => {
          // console.log(indlist);
          
          if(indlist['year'] == this.editweightfilter['ay']){
            let fnaldata = [];
            Object.keys(this.reportsdata).forEach(status => {
              Object.keys(this.reportsdata[status]).forEach(stateid=>{
                  let id = this.reportsdata[status][stateid]['type'] == 'THEME' ? theme['entityUUID'] : indlist['entityUUID'];
                  if(stateid == id){
                    let obj = this.reportsdata[status][stateid];
                    obj['sno'] = indlist['sno'];
                    obj['label'] = indlist['label'];
                    obj['editable'] = true;
                    obj['value'] = status == "pending" ? obj['val'] :
                    (status == "modify" ? obj['updatedVal'] : ((status == "approved" || status =="reject") && obj['updatedVal'] ? obj['updatedVal']: obj['val']))
                    indlist['value'] = obj['value'];
                    if(obj['isReady'] == false){
                      obj['editable'] = false;
                    } else {
                      checkisready++;
                    }
                    if(obj['type'] == 'THEME'){
                      theme['value'] = obj['value'];
                      theme['editable'] = obj['editable'];
                    } else {
                      fnaldata.push(obj);
                    }
                  } 
                  
                // });
                
              }) 
            }) 
            if(fnaldata){
              fnaldata.forEach(element=>{
              i++
              if(i == 1){
                this.tableData.push(theme);
              }
              this.tableData.push(element);
            });
            }
          }
        });
      });
      if(checkisready > 0){
        this.showbuttons = true;
      } else {
        this.showbuttons = false;
      }
  }
  valueChanged(list){
    list['modified'] = this.checkValueIsChanged(list);
    this.checkingvalue(list);
  }

  checkValueIsChanged(data){
    let flag = true;
    Object.keys(this.reportsdata).forEach(type=>{ 
      Object.keys(this.reportsdata[type]).forEach(indid=>{
        if(indid == data.entityUUID){
          let obj = this.reportsdata[type][indid][this.editweightfilter['lu']];
          let value = type == "pending" ? obj['val'] :
                  (type == "modify" ? obj['updatedVal'] : ((type == "approved" || type =="reject") && obj['updatedVal'] ? obj['updatedVal']: obj['val']))
          if(value == data['value']){
            flag = false;
          }
        }
      })
    })
    return flag;
  }
  valuemodified(table,event){
    // console.log("table",table,event);
    // console.log("value",this.labelData)
    table['modified'] = true;
    // console.log(table)
  }

  checkingvalue(list) {
    if(list['type']=='THEME')
    {
      let sum=0, val1, count=0;
      val1 = +list['value'];
      this.tableData.forEach(key => {
        count = 0
        Object.values(list['childList']).forEach(ob => {
          if(ob['entityUUID']==key['id'] && count==0)
          {
            count++;
            let y = +key['value']
            sum += y
          }
        })  
      })
      console.log("sum=>", sum, "value=>", val1)
      if(val1==sum)
        console.log("true")
      else 
        this.toastr.error(" Theme value and sum of indicator should be equal")
    }
  }
    mandatoryCheck(){
      if(this.utils.checkfield(this.editweightfilter['ay'])){
        this.validation['ay'] = true;
      }else{
        this.validation['ay'] = false;
      }
  
      if(this.utils.checkfield(this.editweightfilter['month'])){
        this.validation['month'] = true;
      }else{
        this.validation['month'] = false;
      }
      // if(this.utils.checkfield(this.selectedstate)){
      //   this.validation['state'] = true;
      // } else{
      //   this.validation['state'] = false;
      // }
      // if(this.utils.checkfield(this.showdistdrop && this.selecteddistrict)){
      //   this.validation['district'] = true;
      // } else{
      //   this.validation['district'] = false;
      // }
      return this.validation['ay'] && this.validation['month']
      //  && this.validation['state'] && this.validation['district']
    }
    submitweights(){
      let postdata = {
        "action" : this.constants.ACTION['modify'],
        "userId" : this.userdetails['loggedUserData']['userProfile']['userId'],
        "subTp" : this.editweightfilter['month'],
        "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
        "view" : this.constants.VIEWS['admin'],
        "component" : this.constants.COMPONENT['WEIGHTS_DATA'],
        "ay" : this.editweightfilter['ay'],
        "userType" : this.userdetails['roles'][0],
        "lu" : this.selecteddistrict,
      }
      postdata['data'] = JSON.stringify(this.uploadSubIndicators());
    // if(postdata['data'].length > 0){
     this.activeSpinner = true;
      // postdata['data'] = JSON.stringify({[this.editweightfilter['ay']]:postdata['data']});
      this.submitdataSerivce.modifyData(postdata).subscribe(data =>{
        if(data['status']){
          this.toastr.success('Updated Successfully');
          this.getWeightsData();
        }  else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        }
        this.activeSpinner = false;
      });
    // } else {
    //   this.toastr.warning('Please change atleast one weight data')
    // }
    }
    fomatModifydata(){
      let array = [];
      this.tableData.forEach(list=>{
        if(list['modified']){
          let obj = {
            "id" : list['id'] ? list['id'] : list['entityUUID'],
            "value" : list['value']
          }
          array.push(obj);
        }
      })
      return array;
    }
    reset(){
      // this.initializeOnStateLoad('callweights')
      this.fetchWeightData()
    }
    fetchWeightData(){
      if(this.mandatoryCheck()){
        this.showtabledata = true;
        this.activeSpinner = true;
        this.fetchtableData = [];
        let weightdataparams = {
          "ay" : this.editweightfilter['ay'],
          "view" : this.constants.VIEWS['admin'],
          "component":this.constants.COMPONENT['WEIGHTS_DATA'],
          "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
          "userType" : this.userdetails['roles'][0],
          //"lu" : this.selecteddistrict,
          "subTp" : this.editweightfilter['month'],
          "pu" : "ALL"
          //"stateId": this.selectedstate
        }
        this.submitdataSerivce.fetchdataForWeights(weightdataparams).subscribe(weightdata =>{
          this.activeSpinner = false;
          this.fetchweights = this.formatfetchData(weightdata);
            
          this.dateofmeetingLabel = (this.fetchweights[10]['label'] == "Meeting at DGC " || this.fetchweights[11]['label'] =="kbewkhjfojehrf");
          // this.getlabels(this.fetchweights);
        })
      }
     
    }
    formatfetchData(weightdata){
      if(weightdata && weightdata.length >0)
        weightdata.forEach(element => {
          if(element['childList']){
            element['childList'].forEach(indicator => {
              if(indicator['label'] && indicator['label'] == "Percentage gap between Solid waste generated & solid waste actually treated in the town- across all ULBs within the district"){
                indicator['sno'] = "2.10";
              }
            })
          }

        })
        return this.sortingdata(weightdata);
    }
    sortingdata(data){
      if (data && data.length > 0)
      data.forEach(element => {
        if (element['childList'] && element['childList'].length > 0) {
          element['childList'].sort((a, b) => {
            let sno1 = parseInt(a['sno'].replace('.', ''));
            let sno2 = parseInt(b['sno'].replace('.', ''));
            return sno1 > sno2 ? 1 : -1;
          })
        }
      });
    return data;
    }
    // getlabels(data){
    //   let serialNumber = 0;
    //  Object.values(data).forEach(obj =>{
    //    let labeldata = {label : obj['label'],weight :obj['weight'],type:obj['type'],sno:obj['sno'],editable : true,snoId :serialNumber};
    //    this.labelData.push(labeldata);
    //    console.log("labels",this.labelData)
    //    if(obj!= null && obj!= undefined && obj.hasOwnProperty('childList') && obj['childList']!=null && obj['childList']!=undefined ){
    //      this.getlabels(obj['childList']);
    //    }
    //  })
    // }
    modifyparentData(data){
      // console.log("hhhhhhh")
      let count = 0;
      data['childList'].forEach(row => {
        row['modified'] = true;
        count += Number(row['weight'])
      });
      data['weight'] = count;
    }
    uploadSubIndicators(){
      let obj = {
        [this.editweightfilter['ay']] : []
      }
      this.fetchweights.forEach(element => {
        element['childList'].forEach(indicator => {
          if(indicator['childList']!=null && indicator['childList'].length>0){
             indicator['childList'].forEach(subind => {
              //  this.childList = [];
              if(subind['modified']){
                obj[this.editweightfilter['ay']].push({"id":indicator['entityUUID'],"value":indicator['weight']},{"id":subind['entityUUID'],"value":subind['weight']});
              }
            });
            // if(this.childList.length>0){
            //   obj[this.editweightfilter['ay']].push({"id":indicator['entityUUID'],"value":indicator['weight'],"childData":this.childList})
            // }
          }
          });
          });
          // console.log("obj",obj)
          return obj;  
    }
  

}
